import { OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import type { Nullable } from '@/types'

@OrmModel(modelNames.OAUTH_SIGN_UP)
export default class OAuthSignUp extends BaseModel {
  @StringField()
  public token: string

  @StringField()
  public username: string

  @StringField()
  public email: string

  @StringField(null)
  public firstName: Nullable<string>

  @StringField(null)
  public lastName: Nullable<string>
}
